var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.showBorder ? 'show_border' : '',style:(_vm.ImgStyle),attrs:{"src":_vm.actual_src}})}
var staticRenderFns = []

export { render, staticRenderFns }